import { Inventario } from 'src/drheranca/types';
import { ASSET_CATEGORIES } from '../definitions/assetCategories';
import { VALUATION_BASE_COLUMNS } from '../definitions/valuationBases';
import { ExcelCellValue, ExcelSheetData } from '../types';
import { getAssetValueByPurpose, getInventarioAssets } from '../utils/assetValues';

export interface ValuationBasesAssetRow {
  categoryLabel: string;
  descricao: string;
  valorObito: number;
  valorEscritura: number;
  valorPartilha: number;
  hasMultipleBases: boolean;
}

export function collectValuationBasesRows(inventario: Inventario): ValuationBasesAssetRow[] {
  const rows: ValuationBasesAssetRow[] = [];
  ASSET_CATEGORIES.forEach(({ key, label }) => {
    const assets = getInventarioAssets(inventario, key);
    assets.forEach((a, idx) => {
      const valorObito = getAssetValueByPurpose(a, 'DATA_OBITO');
      const valorEscritura = getAssetValueByPurpose(a, 'DATA_ESCRITURA');
      const valorPartilha = getAssetValueByPurpose(a, 'DATA_PARTILHA');
      if (valorObito <= 0.01 && valorEscritura <= 0.01 && valorPartilha <= 0.01) return;
      const distinct = new Set([
        valorObito.toFixed(2),
        valorEscritura.toFixed(2),
        valorPartilha.toFixed(2),
      ]);
      rows.push({
        categoryLabel: label,
        descricao: (a.descricao as string) || `${label} ${idx + 1}`,
        valorObito,
        valorEscritura,
        valorPartilha,
        hasMultipleBases: distinct.size > 1,
      });
    });
  });
  return rows;
}

export function buildValuationBasesExcelSheet(inventario: Inventario): ExcelSheetData {
  const header: ExcelCellValue[] = [
    'Bem',
    'Categoria',
    ...VALUATION_BASE_COLUMNS.map((c) => c.header),
  ];
  const rows: ExcelCellValue[][] = [header];
  let totalObito = 0;
  let totalEscritura = 0;
  let totalPartilha = 0;

  collectValuationBasesRows(inventario).forEach((r) => {
    rows.push([
      r.descricao,
      r.categoryLabel,
      r.valorObito > 0.01 ? r.valorObito : null,
      r.valorEscritura > 0.01 ? r.valorEscritura : null,
      r.valorPartilha > 0.01 ? r.valorPartilha : null,
    ]);
    totalObito += r.valorObito;
    totalEscritura += r.valorEscritura;
    totalPartilha += r.valorPartilha;
  });

  if (rows.length > 1) {
    rows.push([
      'Total',
      'Soma das bases de avaliação por finalidade',
      totalObito,
      totalEscritura,
      totalPartilha,
    ]);
  }

  return {
    rows,
    colWidths: [40, 28, 24, 30, 30],
    valueColumnStart: 2,
  };
}
